import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import TextAreaField from '../../../components/Forms/Input/TextAreaField';

const PurchaseExtraInfoView = () => {
  const { form } = useBasePurchase();

  return (
    <div className="mt-6 space-y-6 rounded border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <TextAreaField
        name="comments"
        label="Comentarios (Uso Interno)"
        placeholder="Comentarios/Observaciones"
        value={form.comments || ''}
        onChange={() => {}}
        disabled
      />
    </div>
  );
};

export default PurchaseExtraInfoView;
